/**
 * FCM 토큰 Firestore 저장
 * - RN에서 PUSH_TOKEN 메시지로 토큰 수신
 * - Firestore fcmTokens 컬렉션에 저장
 * - 문서 ID: {uid}_{platform}
 */
import { db } from '../firebase/config';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

export const saveFcmToken = async (uid, token, platform = 'android') => {
  if (!uid || !token) return;

  const docId = `${uid}_${platform}`;
  await setDoc(doc(db, 'fcmTokens', docId), {
    uid,
    token,
    platform,
    updatedAt: serverTimestamp(),
  }, { merge: true });
};
